import * as React from 'react';

import TransComp from 'shared/components/TransComp';
import { WithLabelProps } from 'shared/entities/components/WithLabel';

import './WithLabel.modules.scss';

const WithLabel: React.FC<WithLabelProps> = ({
  children,
  label = (t) => t('withLabel.new', { ns: 'components' }),
  className,
  labelClassName
}) => {
  return (
    <div className={className} styleName="container">
      {children}
      <div styleName="container__label" className={labelClassName}>
        <TransComp>{label}</TransComp>
      </div>
    </div>
  );
};

export default React.memo(WithLabel);
